<template>
    <div class="main-panel">
        <h1>Manage Credit</h1>
        <p>User ID: {{ userId }}</p>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useRoute } from "vue-router";

    export default defineComponent({
        setup() {
            const route = useRoute();
            const userId = route.params.userId;  

            return { userId };
        },
    });
</script>
